import {Concept} from 'types';
import type {CodeListId} from 'services/codelists/types';

// ----- Codelist references ----------------------------------------------------------------
export const CodeListRef = {
  LITERATURE_TYPE: {
    ['Faglitteratur']: '10',
    ['Lærebøker (høyere utd.)']: '11',
    ['Skjønnlitteratur']: '12',
    ['Skolebøker']: '13',
    ['Schoolbooks']: '13', // Shortcut
  },
  DEWEY_SOURCE: {
    ['23/nor']: '15',
    ['3/nor']: '16',
    ['23/eng']: '19',
  },
  INTELLECTUAL_LEVEL: {
    ['0-3']: '10',
    ['3-6']: '12',
    ['6-9']: '13',
    ['9-12']: '14',
    ['12-16']: '11',
    ['16-20']: '16',
    ['Voksen']: '15',
  },
  EDUCATION_LEVEL: {
    ['1. trinn']: '1',
    ['2. trinn']: '2',
    ['3. trinn']: '3',
    ['4. trinn']: '4',
    ['5. trinn']: '5',
    ['6. trinn']: '6',
    ['7. trinn']: '7',
    ['8. trinn']: '8',
    ['9. trinn']: '9',
    ['10. trinn']: '10',
    ['VG1']: 'VG1',
    ['VG2']: 'VG2',
    ['VG3']: 'VG3',
  },
  WORK_ROLE_TYPE: {
    ['Forfatter']: 'A01',
    ['Med']: 'A02', // Deaktivert
    ['Manus av']: 'A03',
    Billedkunstner: 'A07',
    Fotograf: 'A08',
    ['Redaktør']: 'B01',
  },
  EXPRESSION_FORMAT: {
    TEXT: 'TEXT',
    ILLUSTRATED_TEXT: 'ILLUSTRATED_TEXT',
    AUDIO: 'AUDIO',
  },
  EXPRESSION_ROLE_TYPE: {
    ['Forfatter']: 'A01',
    ['Komponist']: 'A06',
    ['Illustrert av']: 'A12',
    ['Fotografier av']: 'A13',
    ['Redaktør']: 'B01',
    ['Oversatt av']: 'B06',
    ['Lest av']: 'E07',
    ['Solist (vokal)']: 'E05',
    ['Solist (instrumental)']: 'E06',
    ['Innleser']: 'E07',
    ['Omslag av']: 'A36',
  },
  LANGUAGE: {
    ['Nynorsk']: 'nno',
    ['Bokmål']: 'nob',
    ['Engelsk']: 'eng',
    ['Nordsamisk']: 'sme',
    ['Dansk']: 'dan',
    ['Svensk']: 'swe',
    ['Flerspråklig']: 'mul',
  },
  PRODUCT_FORM: {
    ['Udefinert']: '00',
    ['Lyd']: 'AA',
    ['Lydkassett']: 'AB',
    ['CD (lyd)']: 'AC',
    ['DAT (lyd)']: 'AD',
    ['Lyddisk']: 'AE',
    ['Lydbånd']: 'AF',
    ['MiniDisc']: 'AG',
    ['Lyd- og data-CD']: 'AH',
    ['DVD (lyd)']: 'AI',
    ['Lydfil']: 'AJ',
    ['MP3-spiller med innhold']: 'AK',
    ['SD minnekort med innnhold']: 'AL',
    ['LP']: 'AM',
    ['Nedlastbar og nettbasert (online) lydfil']: 'AN',
    ['Nettbasert (online) lydfil']: 'AO',
    ['Annet lydformat']: 'AZ',
    ['Bok']: 'BA',
    ['Innbundet']: 'BB',
    ['Heftet']: 'BC',
    ['Løse ark']: 'BD',
    ['Spiralbundet']: 'BE',
    ['Stiftet']: 'BF',
    ['Praktinnbinding']: 'BG',
    ['Pappbok']: 'BH',
    ['Tekstilbok']: 'BI',
    ['Badebok']: 'BJ',
    ['Eksperimentell innbinding']: 'BK',
    ['Fleksibind']: 'BL',
    ['Tavlebok']: 'BM',
    ['Utdrag, del av større verk']: 'BN',
    ['Leporello (brettet)']: 'BO',
    ['Skumgummibok']: 'BP',
    ['Annet bokformat']: 'BZ',
    ['Kart, uspesifisert']: 'CA',
    ['Kart, falset']: 'CB',
    ['Kart, plano']: 'CC',
    ['Kart, rullet']: 'CD',
    ['Globus']: 'CE',
    ['Annet kartografisk format']: 'CZ',
    ['Digitalt format (på fysisk bærer)']: 'DA',
    ['CD-I']: 'DC',
    ['Diskett']: 'DF',
    ['Secure Digital (SD) (minnekort)']: 'DJ',
    ['Compact Flash (minnekort)']: 'DK',
    ['Memory Stick (minnekort)']: 'DL',
    ['Tosidig CD/DVD']: 'DN',
    ['Annet digitalt format (på fysisk bærer)']: 'DZ',
    ['Digitalt format (leveres elektronisk)']: 'EA',
    ['Digitalt format, nedlastbart og nettbasert (online)']: 'EB',
    ['Digitalt format, nettbasert (online)']: 'EC',
    ['Digitalt format, nedlastbart (download)']: 'ED',
    ['E-bok']: 'ED', // Shortcut
    ['Ebok']: 'ED', // Shortcut
    ['Film eller lysark']: 'FA',
    ['Lysbilder']: 'FC',
    ['Lysark']: 'FD',
    ['Filmremse']: 'FE',
    ['Film']: 'FF',
    ['Annet film- eller lysarkformat']: 'FZ',
    ['Digitalt produkt, lisens']: 'LA',
    ['Digitalt produkt, lisensnøkkel']: 'LB',
    ['Digitalt produkt, lisenskode']: 'LC',
    ['Mikroform']: 'MA',
    ['Mikrofiche']: 'MB',
    ['Mikrofilm']: 'MC',
    ['Andre mikroformat']: 'MZ',
    ['Diverse trykk']: 'PA',
    ['Adressebok']: 'PB',
    ['Kalender']: 'PC',
    ['Kort']: 'PD',
    ['Kopieringsoriginaler']: 'PE',
    ['Dagbok']: 'PF',
    ['Frise']: 'PG',
    ['Eske/samlesett']: 'PH',
    ['Notetrykk']: 'PI',
    ['Postkort']: 'PJ',
    ['Plakat']: 'PK',
    ['Minnebok']: 'PL',
    ['Mappe eller omslag']: 'PM',
    ['Bilder eller fotografier']: 'PN',
    ['Plansje']: 'PO',
    ['Klistremerker']: 'PP',
    ['Ark']: 'PQ',
    ['Notatbok']: 'PR',
    ['Syvende sans']: 'PS',
    ['Bokmerke']: 'PT',
    ['Brosjyre']: 'PU',
    ['Bokeiermerke']: 'PV',
    ['Andre trykte artikler']: 'PZ',
    ['Produkt bestående av flere enkeltprodukter']: 'SA',
    ['Produkt bestående av flere enkeltprodukter, i eske']: 'SB',
    ['Produkt bestående av flere enkeltprodukter, i kassett']: 'SC',
    ['Produkt bestående av flere enkeltprodukter, plastpakket']: 'SD',
    ['Produkt bestående av flere enkeltprodukter, ikke emballert']: 'SE',
    ['Produkt bestående av flere enkeltprodukter, del(er) er lagt ved']: 'SF',
    ['Video']: 'VA',
    ['Videodisk']: 'VF',
    ['DVD video']: 'VI',
    ['VHS video']: 'VJ',
    ['Betamax video']: 'VK',
    ['HD DVD']: 'VN',
    ['Blu-ray']: 'VO',
    ['UMD Video']: 'VP',
    ['CBHD']: 'VQ',
    ['Andre videoformater']: 'VZ',
    ['Markedsføringsmateriell']: 'XA',
    ['Tilbudskasse – tom']: 'XB',
    ['Tilbudskasse – fylt']: 'XC',
    ['Diskeske – tom']: 'XD',
    ['Diskeske- fylt']: 'XE',
    ['Reklameplakat']: 'XF',
    ['Hyllemarkør']: 'XG',
    ['Vindusmateriell']: 'XH',
    ['Gulvstativ (uten innhold)']: 'XJ',
    ['Forstørret omslag']: 'XK',
    ['Plastpakket']: 'XL',
    ['Pakke (i eske)']: 'XM',
    ['Pakke (emballasje er ikke spesifisert)']: 'XN',
    ['Gulvstativ (med innhold)']: 'XO',
    ['Annet reklamemateriall - inkludert produkter']: 'XY',
    ['Annet reklamemateriell']: 'XZ',
    ['Varer, uspesifisert']: 'ZA',
    ['Dukke eller figur']: 'ZB',
    ['Myk leke']: 'ZC',
    ['Leke']: 'ZD',
    ['Spill']: 'ZE',
    ['T-skjorte']: 'ZF',
    ['Lesebrett']: 'ZG',
    ['Nettbrett']: 'ZH',
    ['Lydbokspiller']: 'ZI',
    ['Puslespill']: 'ZJ',
    ['Kopp']: 'ZK',
    ['Handlenett']: 'ZL',
    ['Servise']: 'ZM',
    ['Paraply']: 'ZN',
    ['Maling, fargestifter, fargeblyanter']: 'ZO',
    ['Andre leker/spill/tilbehør']: 'ZX',
    ['Andre klær']: 'ZY',
    ['Andre varer']: 'ZZ',

    /** Digitalt format, nedlastbart og nettbasert (online) */
    ['EB']: 'EB',
    /** "Digitalt format, nedlastbart (download)" */
    ['ED']: 'ED',
  },
  PRODUCT_FORM_DETAIL: {
    ['EPUB']: 'E101',
    ['OEB']: 'E102',
    ['MP3-format']: 'A103',

    ['Innbundet (papirvarer)']: 'P201',
    ['Heftet (papirvarer)']: 'P202',
    ['Spiral (papirvarer)']: 'P203',
    ['Lærinnbinding / luksusinnbinding (papirvarer)']: 'P204',

    ['Flere måneder per side']: 'P096',
    ['En måned per side']: 'P097',
    ['Ei uke per side']: 'P098',
    ['En dag per side']: 'P099',
    ['Bordkalender']: 'P101',
    ['Veggkalender']: 'P106',
    ['Adventskalender']: 'P108',

    ['Vannavvisende / værbestandig']: 'B521',
  },
  PRODUCT_GROUP: {
    'Grunnskole, diverse': '11000',
    'Grunnskole, diverse ebøker': '11001',
    'Grunnskole, diverse lydbøker': '11002',
    Astronomi: '27015',
    'Astronomi ebøker': '27016',
    'Astronomi lydbøker': '27017',
    Kryssordbøker: '39585',
    'Kryssordbøker ebøker': '39586',
    'Kryssordbøker lydbøker': '39587',
    Humor: '45010',
    Prefix_Barnebøker: '46',
    '2 + Billedbøker': '46020',
    Prefix_Ungdomsbøker: '47',
    'Registre og skilleblad': '50020',
    'Dagbøker og avtalebøker': '55021',
    Kontor: '60000',
    Hobbybøker: '64530',
    TegneOgMaleboker: '64540',
    Tidsskrifter: '85030',
    'Kart og globuser, diverse': '71500',
    'Topografiske kart / turkart': '71510',
    'Kart, bilkart, bykart - Norge': '71520',
    'Kart, bilkart, bykart - utland': '71530',
    Sjøkart: '71540',
  },
  BOOK_GROUP: {
    'Annet. Sammensatte produkter': '838',
  },
  collection_type: {
    Serie: Concept.series,
    Læreverk: Concept.educationalSeries,
    'Annen tilknytning': Concept.otherConnection,
    Forlagsserie: Concept.publisherSeries,
  },
  TEACHING_MATERIALS: {
    Lettlest: '10',
    Tavleressurser: '22',
  },
  WORK_TYPE: {
    Bok: 'BOOK',
    Vare: 'MERCHANDISE',
  },
  PRIZE_TYPE: {
    Author: 'AUTHOR',
    Illustrator: 'ILLUSTRATOR',
    Translator: 'TRANSLATOR',
    Narrator: 'NARRATOR',
    None: 'NONE',
  },
} as const;

// Assigned to typed const to verify valid codelist ids
type ActualKeys = keyof typeof CodeListRef;
const ak: ActualKeys = 'EXPRESSION_FORMAT' as ActualKeys;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const vk: CodeListId = ak;
